import { ContactInfo } from "./ContactInfo";
import { RetailerLocation } from "./RetailerLocation";
import { VisibilityStatus } from "./VisibilityStatus";

export interface Retailer {
    id: string;
    name: string;
    description: string;
    webSiteUrl: string;
    smallImageUrl: string;
    largeImageUrl: string;
    links: RetailerLink[];
    categoryIds: string[];
    visibility: VisibilityStatus;
}
export interface RetailerWithLocations extends Retailer {
    locations: RetailerLocation[];
}

export interface RetailerLink {
    name: string;
    type: RetailerLinkType;
    url: string;
}

export enum RetailerLinkType {
    Website = 1,
    Reservations = 2,
    OnlineOrdering = 3,
    Facebook = 101,
    Twitter = 102,
    Instagram = 103,
    Google = 104,
    Other = 500
}